import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { Ticket, TicketType, User } from 'src/app/models';
import { TcDataService, TcSingleTicketPageUtilsService } from 'src/app/shared/services';
import { Observable, Subject } from 'rxjs';
import { constants } from '@app/shared/utils/constants';

@Component({
  selector: 'ts-others-tab',
  templateUrl: './ts-others-tab.component.html',
  styles: [],
  standalone: false,
})
export class TsOthersTabComponent implements OnInit {
  @Input() unconfirmedTicket?: Ticket;
  @Input() userExec?: User;
  @Input() usersPart: User[] = [];
  @Input() users?: Observable<User[]>;
  @Input() usersInput = new Subject<string>();
  @Input() loadingUsers = false;
  @Input() wasValidated?: boolean;
  @Input() defaultPageSize;

  @Output() cleanExpectedDate = new EventEmitter();
  @Output() updateUserExec = new EventEmitter<User>();
  @Output() updateUsersPart = new EventEmitter<User[]>();

  @ViewChild('form') private form?: NgForm;

  ticketsTypes = constants.ticketcenter.ticketsTypes;
  ticketsReleaseSituations = constants.ticketcenter.ticketsReleaseSituations;
  tags: any[] = [];
  showSolution = false;
  showObservation = false;
  formEditTicketOther!: FormGroup;

  constructor(
    private singleTicketPageUtilsService: TcSingleTicketPageUtilsService,
    public dataService: TcDataService,
    private formBuilder: FormBuilder
  ) {
    this.formEditTicketOther = this.formBuilder.group({
      estimatedEffort: [null],
      ignoreTask: [false],
      commercialEstimatedEffort: [null],
      userOpened: [null],
      userOpenedName: [null],
      executor: [null],
      phaseTicket: [null],
      sprintTicket: [null],
      ticketIssues: [null],
      ticketProject: [null],
      requesterTicket: [null],
      phoneTicket: [null],
      analysisExpectedDateTicket: [null],
      developmentExpectedDateTicket: [null],
      usersPartTicket: [null],
      emailTicket: [null],
      expectedDateStringTicket: [null],
      type: [null],
      ticketTypeCall: [null, Validators.required],
      tagsTicket: [null],
      releaseSituation: [null],
    });
  }

  ngOnInit(): void {}

  changeTicketType(ticketType: TicketType) {
    // if (ticketType) {
    //   let oldType = this.ticketsTypes.filter(i => {
    //     return i.label === ticketType.description;
    //   })
    //   let newType = this.ticketsTypes.filter(i => {
    //     return i.value === ticketType.type;
    //   })
    //   if (newType.length && oldType.length && (ticketType.description == oldType[0].label)) {
    //     ticketType.description = newType[0].label;
    //   }
    // }
  }

  autoCompleteTags: string[] = [];
  loadingTags = false;

  toggleSolution() {
    this.showSolution = !this.showSolution;
  }

  toggleObservation() {
    this.showObservation = !this.showObservation;
  }

  convertTagsToStrings() {
    this.tags = [];

    if (this.unconfirmedTicket!.ticket_tags) {
      this.unconfirmedTicket!.ticket_tags.forEach(ticketTag => {
        this.tags.push({
          display: ticketTag.tag!.name,
          value: ticketTag.tag!.name,
        });
      });
    }
  }

  isFormValid() {
    return this.formEditTicketOther.valid;
  }

  mountFormGroupOtherTab(unconfirmedTicketParam: Ticket) {
    this.unconfirmedTicket = unconfirmedTicketParam;

    this.formEditTicketOther
      .get('ignoreTask')
      ?.setValue(this.dataService.shouldRecalculateTaskEffort);
    this.formEditTicketOther
      .get('estimatedEffort')
      ?.setValue(this.unconfirmedTicket?.estimated_effort);
    this.formEditTicketOther
      .get('commercialEstimatedEffort')
      ?.setValue(this.unconfirmedTicket?.commercial_estimated_effort);
    this.formEditTicketOther.get('userOpened')?.setValue(this.unconfirmedTicket?.user_opened);
    this.formEditTicketOther
      .get('userOpenedName')
      ?.setValue(this.unconfirmedTicket?.user_opened?.name);
    this.formEditTicketOther.get('executor')?.setValue(this.unconfirmedTicket?.executor);
    this.formEditTicketOther.get('phaseTicket')?.setValue(this.unconfirmedTicket?.phase);
    this.formEditTicketOther.get('sprintTicket')?.setValue(this.unconfirmedTicket?.sprint);
    this.formEditTicketOther.get('ticketIssues')?.setValue(this.unconfirmedTicket?.issue);
    this.formEditTicketOther.get('ticketProject')?.setValue(this.unconfirmedTicket?.project);
    this.formEditTicketOther.get('requesterTicket')?.setValue(this.unconfirmedTicket?.requester);
    this.formEditTicketOther.get('phoneTicket')?.setValue(this.unconfirmedTicket?.phone);
    this.formEditTicketOther.get('emailTicket')?.setValue(this.unconfirmedTicket?.email);
    this.formEditTicketOther
      .get('expectedDateStringTicket')
      ?.setValue(this.formatDate(this.unconfirmedTicket?.expected_date));
    this.formEditTicketOther.get('ticketTypeCall')?.setValue(this.unconfirmedTicket?.ticket_type);

    if (this.unconfirmedTicket?.type) {
      let temp = this.ticketsTypes.find(tt => tt.value === this.unconfirmedTicket?.type);

      if (temp) {
        this.formEditTicketOther.get('type')?.setValue(temp);
      }
    }

    if (this.unconfirmedTicket?.release_situation) {
      let temp = this.ticketsReleaseSituations.find(
        tt => tt.value === this.unconfirmedTicket?.release_situation
      );

      if (temp) {
        this.formEditTicketOther.get('releaseSituation')?.setValue(temp);
      }
    }

    if (this.unconfirmedTicket?.ticket_tags?.length) {
      let tags = this.unconfirmedTicket?.ticket_tags.map(ticketTag => ticketTag?.tag?.name);
      this.formEditTicketOther.get('tagsTicket')?.setValue(tags);
    } else {
      this.formEditTicketOther.get('tagsTicket')?.setValue([]);
    }

    this.formEditTicketOther
      .get('analysisExpectedDateTicket')
      ?.setValue(this.formatDate(this.unconfirmedTicket?.analysis_expected_date));
    this.formEditTicketOther
      .get('developmentExpectedDateTicket')
      ?.setValue(this.formatDate(this.unconfirmedTicket?.development_expected_date));
    this.formEditTicketOther.get('usersPartTicket')?.setValue(this.unconfirmedTicket?.participants);
  }

  formatDate(dateString: any) {
    if (dateString != null || dateString != undefined) {
      let date = new Date(dateString);
      let dataFormatada = date.toISOString().split('T')[0];

      return dataFormatada;
    } else {
      return null;
    }
  }

  getTicketForm(): FormGroup {
    return this.formEditTicketOther;
  }

  prepareToSave() {
    this.unconfirmedTicket!.estimated_effort =
      this.formEditTicketOther.get('estimatedEffort')?.value;
    this.unconfirmedTicket!.commercial_estimated_effort = this.formEditTicketOther.get(
      'commercialEstimatedEffort'
    )?.value;
    this.unconfirmedTicket!.phase = this.formEditTicketOther.get('phaseTicket')?.value;
    this.unconfirmedTicket!.sprint = this.formEditTicketOther.get('sprintTicket')?.value;
    this.unconfirmedTicket!.issue = this.formEditTicketOther.get('ticketIssues')?.value;
    this.unconfirmedTicket!.project = this.formEditTicketOther.get('ticketProject')?.value;
    this.unconfirmedTicket!.requester = this.formEditTicketOther.get('requesterTicket')?.value;
    this.unconfirmedTicket!.phone = this.formEditTicketOther.get('phoneTicket')?.value;
    this.unconfirmedTicket!.email = this.formEditTicketOther.get('emailTicket')?.value;
    this.unconfirmedTicket!.expected_date = this.formEditTicketOther.get(
      'expectedDateStringTicket'
    )?.value;
    this.unconfirmedTicket!.ticket_type = this.formEditTicketOther.get('ticketTypeCall')?.value;
    this.unconfirmedTicket!.analysis_expected_date = this.formEditTicketOther.get(
      'analysisExpectedDateTicket'
    )?.value;
    this.unconfirmedTicket!.development_expected_date = this.formEditTicketOther.get(
      'developmentExpectedDateTicket'
    )?.value;
    this.unconfirmedTicket!.type = this.formEditTicketOther.get('type')?.value?.value;
    this.unconfirmedTicket!.user_opened = this.formEditTicketOther.get('userOpened')?.value;

    // A API espera apenas um array de strings (nomes das tags)
    this.unconfirmedTicket!.ticket_tags = this.formEditTicketOther.get('tagsTicket')?.value || [];

    this.unconfirmedTicket!.executor = this.formEditTicketOther.get('executor')?.value;
    this.unconfirmedTicket!.participants = this.formEditTicketOther.get('usersPartTicket')?.value;
    this.unconfirmedTicket!.release_situation =
      this.formEditTicketOther.get('releaseSituation')?.value?.value;
  }

  expectedDateStringChanged(newValue) {
    this.formEditTicketOther.controls['expectedDateStringTicket'].patchValue(newValue);
  }

  updateIgnoreTasks() {
    this.dataService.shouldRecalculateTaskEffort =
      this.formEditTicketOther.get('ignoreTask')?.value;
  }
}
